import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Subheader from 'material-ui/Subheader';


export default class CourseDetailView extends React.Component {
    state = {
      open: false,
    };
  
    handleOpen = () => {
      this.setState({open: true});
    };
  
    handleClose = () => {
      this.setState({open: false});
    };
  
    render() {
      const actions = [
        <FlatButton
          label="Close"
          style={{color:"#009390"}}
          onClick={this.handleClose}
        />,
      ];
  
      return (
        <div style={{ display: 'flex', flexFlow:'row wrap',justifyContent: "flex-start", marginTop:10 }} >
            {this.props.courseTitle}
            <ActionInfo id="infoButton" onClick={this.handleOpen} style={{marginLeft: 15, }} />
          <Dialog
            title={this.props.courseTitle}
            actions={actions}
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose}
            autoScrollBodyContent={true}
          >
           <Subheader inset={false}>INSTRUCTOR: {this.props.courseInstructor}</Subheader>
            {this.props.courseDetails}
          </Dialog>
        </div>
      );
    }
  }


// WEBPACK FOOTER //
// ./src/components/CourseDetail.jsx